/**
 * adminFetch — thin wrapper for /api/admin/* and /api/bloom-gestion-secure/*
 * endpoint calls from admin pages.
 *
 * POST-CUTOVER (Phase 2, 2026-05-09): admin auth is exclusively the OAuth
 * session_token cookie issued by /auth/verify-totp after Google login + TOTP.
 * No more Bearer-from-localStorage. The legacy admin_token cookie/localStorage
 * key is gone with Path 1.
 *
 * Behavior:
 *   - sends credentials:'include' so the session_token cookie is included
 *   - on 401 from an admin endpoint → redirect to /bloom-gestion-secure,
 *     which goes through RequireAdminWithStepUp → re-auth via OAuth.
 *
 * If you're writing a new admin page, you can use this OR a plain
 * fetch(url, {credentials:'include'}). They're equivalent now.
 */
export async function adminFetch(url, options = {}) {
  const res = await fetch(url, { ...options, credentials: 'include' });
  if (res.status === 401 && typeof url === 'string' &&
      (url.includes('/api/admin/') || url.includes('/api/bloom-gestion-secure'))) {
    if (!window.__bloom_admin_redirecting) {
      window.__bloom_admin_redirecting = true;
      try {
        sessionStorage.setItem('bloom_admin_logout_reason',
          'Session expirée. Reconnecte-toi via Google.');
      } catch (e) {}
      window.location.href = '/bloom-gestion-secure';
    }
  }
  return res;
}
